import { __assign, __rest } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
var NavBar = function (_a) {
    var _b;
    var _c = _a.prefixCls, prefixCls = _c === void 0 ? 'pptmui-nav-bar' : _c, _d = _a.fixed, fixed = _d === void 0 ? false : _d, _e = _a.type, type = _e === void 0 ? 'default' : _e, _f = _a.isLeftBlockVisible, isLeftBlockVisible = _f === void 0 ? false : _f, _g = _a.isRightBlockVisible, isRightBlockVisible = _g === void 0 ? false : _g, className = _a.className, titleClassName = _a.titleClassName, leftClassName = _a.leftClassName, rightClassName = _a.rightClassName, children = _a.children, left = _a.left, right = _a.right, onLeftClick = _a.onLeftClick, onRightClick = _a.onRightClick, restProps = __rest(_a, ["prefixCls", "fixed", "type", "isLeftBlockVisible", "isRightBlockVisible", "className", "titleClassName", "leftClassName", "rightClassName", "children", "left", "right", "onLeftClick", "onRightClick"]);
    var wrapperCls = classNames(prefixCls, className, prefixCls + "--" + type, (_b = {},
        _b[prefixCls + "--fixed"] = fixed === true,
        _b));
    var leftCls = classNames(prefixCls + "__left", leftClassName);
    var titleCls = classNames(prefixCls + "__title", titleClassName);
    var rightCls = classNames(prefixCls + "__right", rightClassName);
    var renderLeft = function () {
        return (React.createElement("div", { className: leftCls, onClick: onLeftClick }, left || (isLeftBlockVisible && '返回')));
    };
    var renderRight = function () {
        return (React.createElement("div", { className: rightCls, onClick: onRightClick }, right || (isRightBlockVisible && '设置')));
    };
    return (React.createElement("div", __assign({ className: wrapperCls }, restProps),
        React.createElement("div", { className: prefixCls + "__content" },
            (left || isLeftBlockVisible) && renderLeft(),
            React.createElement("div", { className: titleCls }, children),
            (right || isRightBlockVisible) && renderRight())));
};
export default NavBar;
